import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/public/${string | ':publicLink'}/confirmation/download`;

export const ROUTE: RouteDefinition = `${baseRoute}/public/:publicLink/confirmation/download`;

export const URL = (publicLink: string): RouteDefinition => `${baseRoute}/public/${publicLink}/confirmation/download`;
